module.exports = __webpack_public_path__ + "img/selected4-min.c19e073b.png";